<span
  class="ui-meta-chip"
  [class.ui-meta-chip-neutral]="isNeutral()"
  [class.ui-meta-chip-ok]="isOk()"
  [class.ui-meta-chip-missing]="isMissing()"
  [class.ui-meta-chip-ai]="isAi()"
>
  <span class="ui-meta-chip-icon">
    <ng-content select="[uiMetaChipIcon]" />
  </span>
  <span class="ui-meta-chip-label">
    <ng-content />
  </span>
</span>
